import { Link } from "react-router-dom";
import LogoImg from "./../assets/AyurvedaAssets/images/logo.svg";

// IMPORTING MAIN MENU
import AyurMenu from "./AYMenu";
export default function AYHeader({ serviceLinks, treatmentLinks }) {
  const openMobileMenu = (btn) => {
    btn.classList.toggle("is-active");
    let mobileMenu = document.querySelector(".menu-mobile");
    mobileMenu.classList.toggle("show");
  };

  return (
    <header id="masthead" className="header prt-header-style-01">
      {/* topbar */}
      <div className="top_bar prt-topbar-wrapper clearfix">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="top_bar_contact_item text-center">
                <span className="top_bar_icon">
                  <i className="flaticon flaticon-alert"></i>
                </span>
                We are not inventing anything new; we are restoring what was
                always sacred: clean food, honest living, holistic health, proud
                communities, and ancient wisdom. <a href="#">View more</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* topbar end */}

      {/* site-header-menu */}
      <div id="site-header-menu" className="site-header-menu">
        <div className="site-header-menu-inner prt-stickable-header">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12">
                <div className="d-flex align-items-center justify-content-between">
                  {/* site-navigation */}
                  <div className="site-navigation d-flex align-items-center w-100">
                    {/* site-branding */}
                    <div className="site-branding">
                      <h1>
                        <Link Link to="/">
                          <a className="home-link" title="Medisat" rel="home">
                            <img
                              id="logo-img"
                              height="200"
                              width="200"
                              className="img-fluid auto_size"
                              src={LogoImg}
                              alt="logo-img"
                            />
                          </a>
                        </Link>
                      </h1>
                    </div>
                    {/* site-branding end */}

                    {/* menu-link */}
                    <div className="menu-link">
                      <div
                        className="btn-show-menu-mobile menubar menubar--squeeze"
                        onClick={(e) => openMobileMenu(e.currentTarget)}
                      >
                        <span className="menubar-box">
                          <span className="menubar-inner"></span>
                        </span>
                      </div>

                      {/* menu */}
                      <nav className="main-menu menu-mobile" id="menu">
                        <AyurMenu
                          serviceLinks={serviceLinks}
                          treatmentLinks={treatmentLinks}
                        />
                      </nav>
                      {/* menu end */}
                    </div>
                    {/* menu-link end */}
                  </div>
                  {/* site-navigation end */}

                  <div className="d-flex align-items-center">
                    {/* header_extra */}
                    <div className="header_extra d-flex align-items-center">
                      {/* <div className="contact_item-link">
                        <span>
                          <a href="mailto:info@example.com">
                            contact.vedacare@gmail.com
                          </a>
                        </span>
                      </div> */}
                      {/* <div className="contact_item with-icon">
                        <span>
                          <i className="icon-whatsapp"></i>
                          <a href="tel:1234567890">+123 456 7890</a>
                        </span>
                      </div> */}
                      {/* <ul className="social-icons">
                        <li>
                          <a href="#" rel="noopener" aria-label="facebook">
                            <i className="fontello icon-facebook"></i>
                          </a>
                        </li>
                        <li>
                          <a href="#" rel="noopener" aria-label="twitter">
                            <i className="fontello icon-twitter"></i>
                          </a>
                        </li>
                        <li>
                          <a href="#" rel="noopener" aria-label="linkedin">
                            <i className="icon-linkedin"></i>
                          </a>
                        </li>
                        <li>
                          <a href="#" rel="noopener" aria-label="behance">
                            <i className="fa fa-behance"></i>
                          </a>
                        </li>
                      </ul> */}
                    </div>
                    {/* header_extra end */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* site-header-menu end */}
    </header>
  );
}
